import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setRegionByEmailId } from 'Store/Identity/Region/RegionAction';
import { GET_REGION } from 'Store/Identity/Region/RegionType';
import UserManagementApiService from 'client/utils/clientApiHelper'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getRegionByEmailId(req: any): any {
    try {
        yield put(globalLoaderText("Fetching DropDown Data...."));
        let payloadData : IPayload= {
            apiType : apiType.Identity,
            endpoint : `users/approvaladminregion/${req.emailId}`,
            apiMethod :  apiMethod.GET,
            payload : null
           
        }
        const response = yield call(
            UserManagementApiService.callUserPost,API_URL.PostWebApp,payloadData
        );
        if (response) {
            yield put(setRegionByEmailId(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setRegionByEmailId([]))
        yield put(globalLoaderText(""));
    }
}

function* watchRegion() {
    yield takeEvery(GET_REGION, getRegionByEmailId);
}

export default function* combinedSaga() {
    yield all([
        watchRegion()
    ])
}
